import React, { useState, useEffect } from 'react';
import { Modal, List, Spin, Empty, Tag, Typography } from 'antd';
import { BookOutlined, UserOutlined, LoadingOutlined } from '@ant-design/icons';
import IntlMessages from '@iso/components/utility/intlMessages';
import { educationAssetService } from '@iso/services';

const { Text } = Typography;

const SelectTrainingAssetModal = ({
  visible,
  onCancel,
  onSelect,
  propertyId,
}) => {
  const [loading, setLoading] = useState(false);
  const [educationAssets, setEducationAssets] = useState([]);

  useEffect(() => {
    if (visible && propertyId) {
      setLoading(true);
      educationAssetService.getMyTrainings(propertyId)
        .then((res) => {
          if (res && res.education_assets) {
            setEducationAssets(res.education_assets);
          } else {
            setEducationAssets([]);
          }
        })
        .catch((err) => {
          console.error('Error fetching training assets:', err);
          setEducationAssets([]);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [visible, propertyId]);

  const handleSelect = (asset) => {
    onSelect(asset);
    onCancel();
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case 'course':
        return <Tag color="blue">Course</Tag>;
      case 'training':
        return <Tag color="green">Training</Tag>;
      default:
        return <Tag>{type}</Tag>;
    }
  };

  return (
    <Modal
      title={<IntlMessages id="healthSafety.selectTrainingAsset" />}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 32, color: '#0b2a1b' }} spin />} />
        </div>
      ) : educationAssets.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <div>
              <p style={{ marginBottom: 8, fontWeight: 500 }}>
                <IntlMessages id="healthSafety.noTrainingAssetsAssigned" />
              </p>
              <Text type="secondary">
                <IntlMessages id="healthSafety.noTrainingAssetsDescription" />
              </Text>
            </div>
          }
        />
      ) : (
        <List
          itemLayout="horizontal"
          dataSource={educationAssets}
          renderItem={(asset) => (
            <List.Item
              style={{ cursor: 'pointer', padding: '12px 16px' }}
              onClick={() => handleSelect(asset)}
              className="selectable-list-item"
            >
              <List.Item.Meta
                avatar={<BookOutlined style={{ fontSize: 24, color: '#0b2a1b' }} />}
                title={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>{asset.name}</span>
                    {getTypeLabel(asset.type)}
                  </div>
                }
                description={
                  <div>
                    {asset.primary_trainer_name && (
                      <div style={{ marginBottom: 4 }}>
                        <UserOutlined style={{ marginRight: 4, color: '#0b2a1b' }} />
                        <Text type="secondary">
                          Primary Trainer: {asset.primary_trainer_name}
                        </Text>
                      </div>
                    )}
                    {asset.facility_title && (
                      <div>
                        <Text type="secondary">
                          Linked Asset: {asset.facility_title}
                        </Text>
                      </div>
                    )}
                    {asset.description && (
                      <div style={{ marginTop: 4 }}>
                        <Text type="secondary" ellipsis>
                          {asset.description}
                        </Text>
                      </div>
                    )}
                  </div>
                }
              />
            </List.Item>
          )}
        />
      )}
      <style jsx="true">{`
        .selectable-list-item:hover {
          background-color: #f5f5f5;
        }
      `}</style>
    </Modal>
  );
};

export default SelectTrainingAssetModal;
